export default "__VITE_ASSET__lpbpLwMZ__"